import { useCallback, useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import validate from './validation'
export default (onSuccess, onError) => {
  const [mutation, { data, error, loading }] = useMutation(
    gql`mutation ($recurrentAvailability: EducatorRecurrentAvailabilityInput!, $educatorId: String!) {
        setRecurrentAvailability(recurrentAvailability: $recurrentAvailability, educatorId: $educatorId){
          id
          educatorInfo {
            availabilityBlocks {
              day
              hour
            }
          }
        }
    }`
  )
  const [validationErrors, setValidationErrors] = useState({})
  const submit = useCallback((obj) => {
    const errors = validate(obj)
    if (errors && Object.keys(errors).length) {
      setValidationErrors(errors)
      onError('validation Error')
      return
    }
    mutation({ variables: obj }).then((result) => {
      onSuccess(result)
    }).catch((e) => {
      setValidationErrors({ general: 'misc.apiError' })
      onError(e)
    })
  }, [mutation, onSuccess, onError])
  return { loading, data: data ? data.setRecurrentAvailability : null, error, validationErrors, submit }
}
